import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const FAQItem = ({ question, answer, theme }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div style={{ borderBottom: '1px solid #e2e8f0', padding: '24px 0' }}>
      <div 
        onClick={() => setIsOpen(!isOpen)} 
        style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}
      >
        <h4 style={{ fontSize: '1.1rem', fontWeight: '600', color: theme.secondary, margin: 0 }}>{question}</h4>
        {isOpen ? <ChevronUp size={20} color="#64748b" /> : <ChevronDown size={20} color="#64748b" />}
      </div>
      {isOpen && <p style={{ marginTop: '15px', color: '#475569', lineHeight: '1.6' }}>{answer}</p>}
    </div>
  );
};

const FAQ = ({ theme }) => {
  const faqs = [
    { q: "Is 'Unlimited' really unlimited?", a: "Yes. We don't charge per seat. You can have 500 workers and 50 subcontractors on a single site plan. We bill based on the number of active Sites you manage." },
    { q: "Do workers need to download an app?", a: "No. Workers scan a QR code to sign in, view RAMS, and sign logs. It works in their mobile browser instantly." },
    { q: "Can I export my data if I leave?", a: "Absolutely. Your data belongs to you. You can export all PDFs, logs, and registries to CSV/ZIP at any time with one click." },
    { q: "Does this replace paper permits?", a: "Yes. Our digital permits allow for photos, signatures, and logic checks. You can print them to PDF if you need a physical copy for the site office." }
  ];

  return (
    <section style={{ padding: '100px 20px', maxWidth: '800px', margin: '0 auto' }}>
      <h2 style={{ textAlign: 'center', fontSize: '2.5rem', fontWeight: '800', marginBottom: '60px', color: theme.secondary }}>Frequently Asked Questions</h2>
      {faqs.map((f, i) => <FAQItem key={i} question={f.q} answer={f.a} theme={theme} />)}
    </section>
  );
};

export default FAQ;